import { useState, useEffect } from "react";
import { UserData } from "../Context/DataContext";

const useSubscriptionData = (dublicatedcontent) => {
  const [subscriptionData, setSubscriptionData] = useState({});
  const userData = UserData();

  useEffect(() => {
    let subscriptionData_ = {};
    userData?.products?.forEach((product) => {
      if (product?.id === userData?.BillingData?.plan_name) {
        subscriptionData_ = {
          name: product?.name,
          metadata: product?.metadata,
          price: userData?.BillingData?.last_payment?.total,
          yearsText:
            +product?.metadata?.years > 1
              ? dublicatedcontent.years
              : dublicatedcontent.year,
          years: +product?.metadata?.years,
        };
      }
    });

    if (!subscriptionData_.name && !subscriptionData_.price) {
      subscriptionData_.name = userData?.BillingData?.plan_name?.toUpperCase();
    }

    setSubscriptionData(subscriptionData_);
  }, [userData, dublicatedcontent]);

  return subscriptionData;
};

export default useSubscriptionData;
